import React from "react";

const ListSelect = (props) => {
  const {
    label = "",
    name = "",
    empty = "Select",
    options,
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      {label}
      <div className="input-wrap select-div">
        <select name={name} id={props?.id ?? name} {...extra}>
          <option value="">{empty}</option>
          {options}
        </select>
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default ListSelect;
